<template>
  <div class="keyvisual">
    <div v-html="htmlContent"></div>
  </div>
</template>

<script>
import { setUrlForEvent } from '@/helpers/utils.js'
export default {
  data() {
    return {
      htmlContent: "",
    };
  },
  mounted: function () {
    this.loadHtml()
    setUrlForEvent('keyVisualUrl')
  },
  methods: {
    loadHtml() {
      fetch("./2021tsuruha/tsuruha_htb_2021.html").then((res) => {
        res.text().then((html) => {
          this.htmlContent = html;
        });
      });
    },
  },
};
</script>

<style lang="sass" scoped>
.keyvisual
  padding: 45px 0 0
  color: #000
</style>
